import Vue from 'vue'
import Vuex from 'vuex'
import UserModule from "@/store/modules/UserModule";
import DialogModule from "@/store/modules/DialogModule";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    UserModule,
    DialogModule
  }
})
